import React, { useState } from "react";
import Image from "next/image";
import { MainNavigationItemProps } from "@/types/layout";
import { useRouter } from "next-translate-routes";
import classNames from "classnames";
import { useIsAppOnline } from "@/hooks/useIsAppOnline";
import Link from "next/link";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export const PrimaryNavItem: React.FC<MainNavigationItemProps> = ({ navigationItem, hideBurgerMenu }) => {
  const [hoverIcon, setHoverIcon] = useState(false);
  const router = useRouter();
  const cleanRouterAsPath = router.asPath.replace(/\/+$/, "");
  const cleanFromApiURL = navigationItem.url.replace(/\/+$/, "");
  const isCurrentURL = cleanRouterAsPath === cleanFromApiURL;
  const isAppOnline = useIsAppOnline();
  const isMobile = useMediaQuery(775);

  const iconHoverValidator = navigationItem.iconHover !== false;

  const currentActiveIcon = () => {
    if (hoverIcon || isCurrentURL) {
      if (iconHoverValidator) {
        return navigationItem.iconHover as string;
      }
    }
    return navigationItem.icon;
  };

  const Component: React.FC<React.PropsWithChildren<any>> = (props) => {
    if (!isCurrentURL) {
      return (
        <Link href={navigationItem.title === "Dnes" && !isAppOnline ? "/offline" : navigationItem.url} {...props} />
      );
    }
    return <button type="button" onClick={hideBurgerMenu} {...props} />;
  };

  return (
    <li key={navigationItem.id}>
      <Component
        className={`${classNames({
          "w-full bg-gray-100 dark:bg-white-25": isCurrentURL,
        })} flex items-center px-6 py-3 transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25`}
        onMouseEnter={() => !isMobile && setHoverIcon(true)}
        onMouseLeave={() => !isMobile && setHoverIcon(false)}
      >
        {navigationItem.icon && (
          <>
            {navigationItem.url === "/" ? (
              <>
                {isAppOnline ? (
                  <Image
                    src={currentActiveIcon()}
                    alt={`${navigationItem.title} icon`}
                    width={18}
                    height={18}
                    style={{
                      width: "18px",
                      height: "18px",
                    }}
                    className={`${hoverIcon || isCurrentURL ? "" : "dark:invert"} mr-3`}
                  />
                ) : (
                  <Image
                    src="/assets/images/icons/today-icon.svg"
                    alt={`${navigationItem.title} icon`}
                    width={18}
                    height={18}
                    style={{
                      width: "18px",
                      height: "18px",
                    }}
                    className={`${hoverIcon || isCurrentURL ? "" : "dark:invert"} mr-3`}
                  />
                )}
              </>
            ) : (
              <Image
                src={currentActiveIcon()}
                alt={`${navigationItem.title} icon`}
                width={18}
                height={18}
                style={{
                  width: "18px",
                  height: "18px",
                }}
                className={`${hoverIcon || isCurrentURL ? "" : "dark:invert"} mr-3`}
              />
            )}
          </>
        )}
        <span className="font-condensed text-md text-black dark:text-white">{navigationItem.title}</span>
      </Component>
    </li>
  );
};
